import React from 'react';
import { 
  LayoutDashboard, 
  FileText, 
  Image as ImageIcon, 
  PenTool, 
  Building, 
  Settings,
  Users
} from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';

const AdminNav: React.FC = () => {
  const location = useLocation();
  const currentPath = location.pathname;

  const navItems = [
    { 
      title: 'Dashboard', 
      icon: LayoutDashboard, 
      path: '/admin/dashboard',
      description: 'Overview and statistics'
    },
    { 
      title: 'Applications', 
      icon: FileText, 
      path: '/admin/applications',
      description: 'Manage student applications'
    },
    { 
      title: 'Digital Signatures', 
      icon: PenTool, 
      path: '/admin/signatures',
      description: 'Manage digital signatures'
    },
    { 
      title: 'Property Images', 
      icon: ImageIcon, 
      path: '/admin/images',
      description: 'Manage property images'
    },
    { 
      title: 'Properties', 
      icon: Building, 
      path: '/admin/properties',
      description: 'Manage properties and logo'
    },
    { 
      title: 'Students', 
      icon: Users, 
      path: '/admin/students',
      description: 'View and manage students'
    },
    { 
      title: 'Settings', 
      icon: Settings, 
      path: '/admin/settings',
      description: 'System configuration'
    }
  ];

  return (
    <div className="bg-white shadow-md rounded-lg p-4">
      <nav className="space-y-1">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = currentPath.startsWith(item.path);
          
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`flex items-center px-4 py-3 rounded-lg transition-colors ${
                isActive
                  ? 'bg-blue-50 text-blue-700'
                  : 'text-gray-700 hover:bg-gray-50'
              }`}
            >
              <Icon className={`h-5 w-5 ${isActive ? 'text-blue-500' : 'text-gray-400'}`} />
              <div className="ml-3 flex-1">
                <p className={`text-sm font-medium ${isActive ? 'text-blue-700' : 'text-gray-900'}`}>
                  {item.title}
                </p>
                <p className={`text-xs ${isActive ? 'text-blue-600' : 'text-gray-500'}`}>
                  {item.description}
                </p>
              </div>
              {isActive && (
                <div className="w-1.5 h-8 bg-blue-500 rounded-full ml-4"></div>
              )}
            </Link>
          );
        })}
      </nav>
    </div>
  );
};

export default AdminNav;